import { mixed, object, ObjectSchema, string } from "yup";
import { AddressRequiredText, EmailFormError, PhoneNumberFormError, PONumberRequiredText } from "constants/text";
import { CharacterLimitExceeded } from "constants/text.ts";
import { models } from "types/api/viewModels.ts";

export const CART_PO_NUMBER_MAX_LENGTH = 25;
export const CART_JOB_NAME_MAX_LENGTH = 30;

export interface CartShippingDetailsFormValues {
	poNumber: string;
	jobName?: string | null;
	address?: models["ShipToViewModel"] | null;
	phoneNumber?: string | null;
	email?: string | null;
}

export const cartShippingDetailsSchema: ObjectSchema<CartShippingDetailsFormValues> = object({
	poNumber: string().max(CART_PO_NUMBER_MAX_LENGTH, CharacterLimitExceeded).required(PONumberRequiredText),
	jobName: string().max(CART_JOB_NAME_MAX_LENGTH, CharacterLimitExceeded).nullable(),
	address: mixed<models["ShipToViewModel"]>().nullable().required(AddressRequiredText),
	phoneNumber: string()
		.when(["address", "address.shipToId"], {
			is: (address: models["ShipToViewModel"] | null | undefined) => Boolean(address && !address.shipToId),
			then: (schema) => schema.required(PhoneNumberFormError),
			otherwise: (schema) => schema.nullable()
		})
		.test("isValidPhone", PhoneNumberFormError, (value) => (value ? value.replace(/\D/g, "").length === 10 : true)),
	email: string()
		// eslint-disable-next-line sonarjs/slow-regex
		.matches(/^.+@.+\..+$/, { message: EmailFormError, excludeEmptyString: true })
		.nullable()
});
